import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-dash",
  templateUrl: "dash.html",
})
export class DashPage {
  private styleName: string ="";
  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams) {
    console.log("dash constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
  }
}



// WEBPACK FOOTER //
// ./src/pages/dash/dash.ts